var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineRouteSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.65 16.87-.7-2.07c-.11-.36-.39-.63-.73-.74l-2.08-.7c-1.12-.38-1.84-1.39-1.82-2.57.02-1.18.76-2.17 1.89-2.52l7.53-2.34c.95-.29 1.98-.04 2.68.67.7.71.95 1.73.66 2.68l-2.34 7.54c-.35 1.13-1.34 1.87-2.53 1.89-.01-.01-.02-.01-.03-.01-1.17 0-2.16-.72-2.53-1.83zm4.52-9.52L7.63 9.7c-.61.19-.83.69-.83 1.11-.01.41.2.93.8 1.13l2.08.69c.8.26 1.43.89 1.69 1.7l.69 2.06c.2.6.67.79 1.13.81.41 0 .92-.22 1.11-.83l2.34-7.54c.13-.42.02-.86-.29-1.17a1.13 1.13 0 0 0-.83-.36c-.12 0-.23.02-.35.05z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineRouteSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-route-square.99ad331eadbf8e830bf36f8d103b6de2.svg";
export { ForwardRef as ReactComponent };